export enum LocationType {
    Generic = 0,
    Site = 10,
    Greenhouse = 20,
    Packhouse = 25,
    Row = 30,
    Package = 35,
    Crop = 40,
    Door = 45,
}
